import axios from "axios";
import apiService from "./apiService";
import {nextTick} from "vue";

export default class SettingsService
{
    static async load() {
        let settings = null;
        await axios.get(apiService.settingsEndpoint())
            .then((response) => {
                settings = response.data.data;
            });

        const obj = {};
        // @ts-ignore
        settings.map((item) => {
            obj[item.key_name] = item;
        });
        return obj;
    }
}